
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#989AB2","stroke-width":"1.5","fill":"none !important"}},[_c('path',{attrs:{"d":"M3 7h4.5v5.75A2.25 2.25 0 015.25 15v0A2.25 2.25 0 013 12.75V7zM7.5 7H12v5.75A2.25 2.25 0 019.75 15v0a2.25 2.25 0 01-2.25-2.25V7zM12 7h4.5v5.75A2.25 2.25 0 0114.25 15v0A2.25 2.25 0 0112 12.75V7zM16.5 7H21v5.75A2.25 2.25 0 0118.75 15v0a2.25 2.25 0 01-2.25-2.25V7zM3 7V5a2 2 0 012-2h14a2 2 0 012 2v2"}}),_c('path',{attrs:{"d":"M3 12v7a2 2 0 002 2h14a2 2 0 002-2v-7"}})])])
          )
        }
      }
    